export default __webpack_public_path__ + "af18191b7c71c80b141c28cd13834f5f.jpg";